import { gql } from '@apollo/client';

export const CREATE_DESTINATION = gql`
  mutation createDestination($input: CreateDestinationInput) {
    createDestination(input: $input) {
      created
      id
      name
    }
  }
`;

export const CREATE_INTEREST = gql`
  mutation createInterest($email: String) {
    createInterest(email: $email) {
      id
      status
    }
  }
`;

export const UPDATE_DESTINATION = gql`
  mutation updateDestination($input: UpdateDestinationInput) {
    updateDestination(input: $input) {
      created
      id
      name
    }
  }
`;
export const CREATE_ORGANISATION = gql`
  mutation createOrganisation($input: CreateOrganisationInput) {
    createOrganisation(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_ORGANISATION_BILLING_INFORMATION = gql`
  mutation updateOrganisationBillingInformation($input: UpdateOrganisationBillingInput) {
    updateOrganisationBillingInformation(input: $input) {
      status
      modified
    }
  }
`;

export const SEND_INVITE = gql`
  mutation sendInvite($email: String!, $orgId: String!) {
    sendInvite(email: $email, orgId: $orgId) {
      success
      message
    }
  }
`;

export const UPADTE_SCOPES = gql`
  mutation updateUserScopes($orgId: String, $userId: String, $scopes: [String]) {
    updateUserScopes(orgId: $orgId, userId: $userId, scopes: $scopes) {
      success
      message
    }
  }
`;

// SFTP MANAGEMENT
export const CREATE_SFTP_ACCOUNT = gql`
  mutation CreateSftpAccount($input: CreateSftpAccountInput) {
    createSftpAccount(input: $input) {
      created
      id
      modified
      organisationId
      password
      passwordMasked
      status
      username
    }
  }
`;

export const UPDATE_SFTP_ACCOUNT = gql`
  mutation RemoveSftpAccount($input: UpdateSftpAccountInput) {
    updateSftpAccount(input: $input) {
      created
      id
      modified
      organisationId
      passwordMasked
      status
      username
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($input: UpdateUser) {
    updateUser(input: $input) {
      id
      status
      created
      modified
      fName
      lName
      email
    }
  }
`;
